import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { pipe } from '@anewgo/functions';
export var makeQuery = function makeQuery(url) {
  if (url === void 0) {
    url = '';
  }

  return {
    route: url,
    params: []
  };
};
export var addPath = function addPath() {
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  return function (query) {
    return Object.assign({}, query, {
      route: query.route + "/" + items.join('/')
    });
  };
};
export var addParam = function addParam(key) {
  for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    values[_key2 - 1] = arguments[_key2];
  }

  return function (query) {
    return Object.assign({}, query, {
      params: [].concat(query.params, [[key, values.join()]])
    });
  };
};
export var getUrlFromQuery = function getUrlFromQuery(query) {
  var formatParam = function formatParam(_ref) {
    var key = _ref[0],
        value = _ref[1];
    return key + "=" + value;
  };

  var paramsString = query.params.map(formatParam).join('&');
  return query.route + (paramsString && '?') + paramsString;
};
export var executeQuery = pipe(getUrlFromQuery, fetch);